import {PersonalData} from './PersonalData'

// App settings available only for service admins (route `admin/` is registered only for ADMIN)
const AppAdmin = () => {
  return (
    <>
      <PersonalData />
    </>
  )
}

export {AppAdmin}
